/* eslint-disable react/destructuring-assignment */
import React, { useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { ConnectorContext } from '../../context';
import { BTN_ACTIONS } from '../../utils';

export const Footer = () => {
  const {
    state: { returnUri, error, currentApp },
  } = useContext(ConnectorContext);
  const { pathname } = useLocation();

  const stepName = pathname.replace('/connect', '');
  const isInitialPath = stepName === '';
  const { id } = useParams();

  let shouldDisplayCancelButton = false;
  if (currentApp?.steps) {
    const stepsLength = Object.keys(currentApp.steps).length;
    // A step with a Back button of its own has no Cancel under it.
    const hasBackButton = currentApp.steps[id]?.some((item) => item.action === BTN_ACTIONS.BACK);
    shouldDisplayCancelButton = id >= 1 && id < stepsLength && !hasBackButton;
  }

  return (
    <Grid
      container
      item
      justifyContent="center"
      alignItems="center"
      direction="column"
      sx={{ padding: '10px 0 30px' }}
    >
      {!error && (isInitialPath || shouldDisplayCancelButton) ? (
        <Grid item sx={{ width: '100%', textAlign: 'center' }}>
          <Button color="cancelBtnGrey" href={returnUri} data-testid="cancel_btn">
            <FormattedMessage id="cancel_btn" />
          </Button>
        </Grid>
      ) : null}
      <Grid
        item
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ width: '100%' }}
      >
        <Typography
          variant="footer"
          component="span"
          sx={{ textAlign: 'center', display: 'block', width: '100%' }}
          data-testid="footer_message"
        >
          <FormattedMessage id="footer_message" />
        </Typography>
        <a
          className="footer-link"
          href="https://strawbay.io/"
          target="_blank"
          rel="noreferrer"
          data-testid="strawbay_link"
        >
          <img height="14px" width="70px" src="/img/strawbay-logo.png" alt="strawbay.io" />
        </a>
      </Grid>
    </Grid>
  );
};
